// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bSeRu","label":"styles_label__3sB9a"};